<template>
  <div class="teacherlogin">
    <p id="loginText">Educator Login:</p>
    <form @submit="sendLogin">
      <table style="margin-left: auto; margin-right: auto">
        <tr>
          <td><label  for="email_in" style="text-align: right; font-weight: 500;">Email</label></td>
          <td><input type="text" style="display: table-column;" v-model="email" id="email_in" name="email_in" /></td>
        </tr>
        <tr>
        <td><label  for="password_in" style="text-align: right; font-weight: 500;">Password</label></td>
        <td><input type="text" style="display: table-column;" v-model="password" id="password_in" name="password_in" /></td>
        </tr>

        <tr>
        <td><input type="submit" style="display: inline-block" value="Log In" class="button"/></td>
        <td><input type="checkbox" v-on:click="hidePassword">Show Password </td>
        </tr>
      </table>
    </form>
  </div>
</template>

<script>

export default {
  name: 'TeacherLogin',
  components: {

  },
  data() {
    return {
      email: "",
      password: "",
      loggedIn: false
    }
  },
  mounted() {
   this.checkIsLoggedIn();
   this.hidePassword();
  },
  methods: {
    async isLoggedIn() {
      const res = await fetch('api/isloggedin/', {
        method: 'GET',
        credentials: 'include'
      });

      let result = (await res.json());
      return result.result;
    },
    async checkIsLoggedIn() {
      const res = (await this.isLoggedIn());

      if (res) {
        this.$router.push("/teacher");
      }
    },
    async sendLogin(event) {
      event.preventDefault();

      const res = await fetch('api/login/', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({email: this.email, password: this.password})
      });

      let result = (await res.json());

      if (result.success) {
        this.$router.push('/teacher');
      } else {
        alert(result.error);
      }
    },
    hidePassword() {
      var x = document.getElementById("password_in");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    }
  }
}
</script>

<style scoped>
.teacherlogin {
  width: 100%;
}

#loginText {
  top: 50%;
  font-family: system-ui, sans-serif; font-weight: bold;
  font-size: large;
}

.button {
  background-color: var(--form-blue);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 2px;
  margin-top: 10px;
  border: none;
}

.button:hover{
  cursor: pointer;
}
</style>
